<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <b-breadcrumb :items="pages" style="margin: 0px; padding: 5px 14px;"></b-breadcrumb>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-2">
              <div class="label mt-2">Select GRO Site:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="GRO" :options="GRO_options"
                label="Select GRO Site:" @change="onChangeGRO"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">GRO PM Name:</div>
              <b-form-select v-model="gropm" :options="gropm_options" label="GRO PM Name:" @change="onChangeGROPM"></b-form-select>
            </div>
            <div class="col-auto align-self-end">
              <b-button @click="$emit('editSelectionModal', gropm, 'gropm')" variant="primary">Add GRO PM</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="table_show==true">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table striped :fields="fields"
                 :items="GROData" small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(company_id)="data">
            <span>
              {{data.item.company_id}}
            </span>
          </template>

          <template #cell(company_name)="data">
            <span>
              {{data.item.company_name}}
            </span>
          </template>

          <template #cell(gro_pm)="data">
            <span>
              {{data.item.gro_pm}}
            </span>
          </template>

          <template #cell(gro_sa)="data">
            <span>
              <div v-for="i in data.item.gro_sa.length">
                {{ data.item.department[i-1] +"; "+ data.item.gro_sa[i-1] }}
              </div>
            </span>
          </template>

          <template #cell(action)="data">
            <div>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                  @click="$emit('editSelectionModal', data.item, 'gropm')"></button>
              <button  type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                  @click="$emit('deleteModal', 'gropm', data.item, '')"></button>
            </div>
          </template>

        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'admin',
    props: ['GROData', 'gropm_options', 'table_show', ],
    watch: { 
      gropm_options: function(newVal, oldVal) { // watch it
        this.gropm = newVal[0].value
        console.log(newVal)
      }
    },
    data() {
      return {
        // function_name: 'Admin-Memeber Setting-Add GRO PM',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        GRO_options_default: '',
        GRO_options: [{ value: '', text: '---Select One---' }],
        GRO: '',
        GROText: '',
        gropm: '',

        pages: [
          { text: 'Admin-Member Setting', href: '' },
          { text: 'Add GRO PM', active: true }
        ],

        fields: [
          { key: 'company_id', label: 'company_id', thClass: 'align-middle', sortable: false },
          { key: 'company_name', label: 'company_name', thClass: 'align-middle', sortable: false },
          { key: 'gro_pm', label: 'gro_pm', thClass: 'align-middle', sortable: true },
          { key: 'gro_sa', label: 'gro_sa', thClass: 'align-middle', sortable: false },
          { key: 'action', label: 'Actions', thClass: 'align-middle', sortable: false }
        ],
        // searchedData: [],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
      }
    },
    created() {
      let self = this;

    },
    computed: {
      
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.pages[0]['href'] = this.$root.frontEndUrl + "/admin-member/setting"
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        gro_option_new[0].text = '---Select One---'
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;

      },
      onChangeGRO(GRO) {
        let groText = GRO;
        if('' === GRO){
          groText = '---Select One---';
        }
        else {
          let request_data = {
            action: 'load',
            GRO: this.GRO,
          };
          this.$parent.getGRO(request_data);
        }
      },
      onChangeGROPM(gropm) {
        let gropmText = gropm;
        this.gropm = gropm;
        if('' === gropm) {
          gropmText = this.gropm_options[0];
        }
      },
      // exit() {
      //   window.open('', '_self', '');
      //   window.close();
      // }
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MemberSettingAddGRO.vue